import { TableTemplate } from "components/templates/default/table/TableTemplate";
import { Outlet } from "react-router-dom";
import { useCallback, useMemo, useState } from "react";
import { TitleComponentType } from "components/blocks/subheader/SubHeader";
import { PageTotalStatus } from "api/interfaces/commonInterface.interface";
import Status from "components/blocks/status/Status";
import { ClickSearch } from "components/atoms/input/search/SearchInput";

export interface UserPageOutletContext {
  keyword: string;
  setKeyword: React.Dispatch<React.SetStateAction<string>>;
  setStatus: React.Dispatch<React.SetStateAction<PageTotalStatus>>;
  setButtonLabel: React.Dispatch<React.SetStateAction<string>>;
  setTitleComponent: React.Dispatch<React.SetStateAction<TitleComponentType>>;
  setOnClickBtn: React.Dispatch<React.SetStateAction<(() => void) | undefined>>;

  setOnClickSearch: React.Dispatch<React.SetStateAction<ClickSearch>>;
}

export default function UserPage(): JSX.Element {
  const [titleComponent, setTitleComponent] =
    useState<TitleComponentType>("User List");

  const [status, setStatus] = useState<PageTotalStatus>({
    totalTitle: "Total Users",
    totalValue: 0,
  });

  const [keyword, setKeyword] = useState<string>("");
  const [buttonLabel, setButtonLabel] = useState<string>("Add User");
  const [onClickBtn, setOnClickBtn] = useState<(() => void) | undefined>(
    undefined
  );
  const [onClickSearchByOutlet, setOnClickSearchByOutlet] =
    useState<ClickSearch>(() => () => {});

  const onClickSearch = useCallback(
    (keyword: string) => {
      setKeyword(keyword);
      onClickSearchByOutlet(keyword);
    },
    [setKeyword, onClickSearchByOutlet]
  );

  const centerChildren = useMemo(() => {
    return <Status status={status} />;
  }, [status]);

  const outletContext: UserPageOutletContext = {
    keyword,
    setKeyword,
    setStatus,
    setButtonLabel,
    setTitleComponent,
    setOnClickBtn,
    setOnClickSearch: setOnClickSearchByOutlet,
  };
  return (
    <TableTemplate
      titleComponent={titleComponent}
      centerChildren={centerChildren}
      keyword={keyword}
      onClickSearch={onClickSearch}
      requiredPermissions="manageUsersAndGroups"
      buttonLabel={buttonLabel}
      onClickBtn={onClickBtn}
      data-testid="users-user-page-tsx-users-table-template-click"
    >
      <Outlet context={outletContext} />
    </TableTemplate>
  );
}
